
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^([0123456789]|10|11|27)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
